@for (item of assessments; track item) {
	<div>
		<div class="title">{{ item.title }}</div>
		@if (item.points && item.points.length > 0) {
			<ul>
				@for (point of item.points; track point) {
					<li>
						<div>{{ point.description }}</div>
						@if (point.subPoints && point.subPoints.length > 0) {
							<ul>
								@for (subPoint of point.subPoints; track subPoint) {
									<li>{{ subPoint.description }}</li>
								}
							</ul>
						}
					</li>
				}
			</ul>
		}
	</div>
}
